import React from "react";
import { Tooltip } from "antd";

const EllipsisText = ({ text, width = 200, link = false }) => {
  const style = {
    width: width,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
  };

  const content = link ? (
    <div style={{ ...style, color: "#1890ff", cursor: "text" }}>
      {text}
    </div>
  ) : (
    <span style={style}>{text}</span>
  );

  return (
    <Tooltip title={text} placement="topLeft">
      {content}
    </Tooltip>
  );
};

export default EllipsisText;
